<formstep-detail :options="options" :editable="true" :model="team"></formstep-detail>